import { render, staticRenderFns } from "./emailTextElementViewer.vue?vue&type=template&id=3fa6b5ba&scoped=true&"
import script from "./emailTextElementViewer.vue?vue&type=script&lang=js&"
export * from "./emailTextElementViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa6b5ba",
  null
  
)

export default component.exports